import { createAuthenticatedFetch } from './types/core/common';

// Types
export interface FieldConfigCreate {
  reference_id: number;
  condition_id?: number;
  condition_value?: string;
}

export interface FieldConfigResponse extends FieldConfigCreate {
  id: number;
  created_at: string;
  updated_at: string;
}

// Type pour la réponse utilisateur (version courte)
export interface FieldConfigResponseShort {
  reference_id: number;
  condition_id?: number;
  condition_value?: string;
}

const api = createAuthenticatedFetch();

// API Endpoints avec authentification automatique
export const fetchConfigsAdmin = async (): Promise<FieldConfigResponse[]> => {
  return api.get<FieldConfigResponse[]>('/field_config/admin/');
};

export const fetchConfigs = async (): Promise<FieldConfigResponseShort[]> => {
  return api.get<FieldConfigResponseShort[]>('/field_config/');
};

export const createConfig = async (config: FieldConfigCreate): Promise<FieldConfigResponse> => {
  return api.post<FieldConfigResponse>('/field_config/', config);
};

export const updateConfig = async (id: number, config: FieldConfigCreate): Promise<FieldConfigResponse> => {
  return api.put<FieldConfigResponse>(`/field_config/${id}`, config);
};

export const deleteConfig = async (id: number): Promise<void> => {
  return api.delete(`/field_config/${id}`);
}; 